// Translation files for English and Arabic

export const translations = {
  en: {
    // Navbar
    nav: {
      home: "Home",
      services: "Services",
      features: "Features",
      about: "About",
      book: "Book",
      contact: "Contact",
      bookAppointment: "Book appointment"
    },

    // Banner
    banner: {
      title: "Healthy teeth, happy life",
      description: "Dr. Yousof AlSaket is a skilled dentist with a strong foundation in oral and dental medicine and surgery. He earned his Doctor of Dental Surgery (DDS) degree from the University of Jordan. He then got his Membership of the Faculty of Dentistry at the Royal College of Surgeons in Ireland (MFD RCSI). To further enhance his expertise, Dr. Yousof Alsaket completed a fellowship in Aesthetic and Restorative Dentistry at the University of Genoa, Italy. This comprehensive background equips him to provide a wide range of dental services, including general dentistry, oral surgery, and cosmetic procedures.",
      bookAppointment: "Book an appointment",
      takeCareOfSmile: "Take Care Of Your Smile",
      doctorName: "Dr. Yousof Al-Saket",
      consultant: "Consultant"
    },

    // Services
    services: {
      subTitle: "Services",
      title: "Feel amazing about your oral health",
      orthodontic: {
        title: "Orthodontic Treatment",
        description: "Smile confidently. Orthodontics can straighten your teeth and improve your bite."
      },
      implants: {
        title: "Implants",
        description: "Dental implants with Swiss Straumann implants - Internet crowns (all types of crowns) and dental fillings"
      },
      whitening: {
        title: "Whitening",
        description: "Teeth whitening of both types (home / laser whitening) and the latest devices and the best international whitening materials"
      },
      gumCleaning: {
        title: "Gum cleaning",
        description: "Gum cleaning (one channel or two channels or three channels) regular or through the rotary device"
      },
      rootCanal: {
        title: "Root canal treatment",
        description: "Root canal treatment for all teeth using Rotary devices and the latest technology for root canal disinfection and filling."
      }
    },

    // Features
    features: {
      subTitle: "Features",
      title: "Specialized care through experiences",
      description: "Our experience in the field allows us to provide specialized care with professionalism and high mastery, with light hands, magical touches, and a few hours to provide this expertise to be placed in your hands with all its details.",
      safetyFirst: {
        title: "Safety first",
        description: "We prioritize safety with health checks and more"
      },
      insuranceAccepted: {
        title: "Insurance accepted",
        description: "We're in network with major insurers you can go to Insurance section to check your Insurance"
      },
      fullService: {
        title: "Full-service dentistry",
        description: "Our clinic offer a full of dental service, from exams to implants and veneers."
      },
      noJudgment: {
        title: "No judgment ever",
        description: "From floss bosses to sweet tooths, every mouth is welcome."
      }
    },

    // Accredited/Insurance
    accredited: {
      subTitle: "Insurance",
      title: "We are approved by many insurance companies."
    },

    // Appointment
    appointment: {
      subTitle: "BOOK APPOINTMENT",
      title: "Care at Al-Saket Center is pleasure",
      description: "Al-Saket Dental Center Offers Comprehensive Dental Services. Book Your Appointment Now and Benefit from Our State-of-the-Art Facilities and Skilled Dentists",
      bookAppointment: "Book an appointment",
      takeCareOfSmile: "TAKE CARE OF YOUR SMILE HERE",
      location: "Arab Bank Complex Third Floor, Jabal Arafat St, Amman"
    },

    // Contact
    contact: {
      title: "Contact Us",
      description: "Questions? Ready to schedule? Contact us today. We're here to help you achieve the smile you deserve."
    },

    // Footer
    footer: {
      description: "Alsaket Center is a top-rated local practice for cosmetic, preventative, and restorative dentistry on Amman",
      followUs: "Follow us on",
      contactInformation: "Contact & Information",
      phoneNumber: "Phone Number",
      openHour: "Open Hour",
      clinicAddress: "Clinic Address",
      copyright: "AlSaket Dental Clinics. All Right Reserved 2024"
    }
  },

  ar: {
    // Navbar
    nav: {
      home: "الرئيسية",
      services: "الخدمات",
      features: "المميزات",
      about: "من نحن",
      book: "احجز",
      contact: "اتصل بنا",
      bookAppointment: "احجز موعد"
    },

    // Banner
    banner: {
      title: "أسنان صحية، حياة سعيدة",
      description: "الدكتور يوسف الساكت طبيب أسنان ماهر يتمتع بأساس قوي في طب وجراحة الفم والأسنان. حصل على درجة دكتور جراحة الأسنان (DDS) من الجامعة الأردنية. ثم حصل على عضوية كلية طب الأسنان في الكلية الملكية للجراحين في أيرلندا (MFD RCSI). لتعزيز خبرته بشكل أكبر، أكمل الدكتور يوسف الساكت زمالة في طب الأسنان التجميلي والترميمي في جامعة جنوة، إيطاليا. هذه الخلفية الشاملة تؤهله لتقديم مجموعة واسعة من خدمات طب الأسنان، بما في ذلك طب الأسنان العام، وجراحة الفم، والإجراءات التجميلية.",
      bookAppointment: "احجز موعد",
      takeCareOfSmile: "اعتنِ بابتسامتك",
      doctorName: "د. يوسف الساكت",
      consultant: "استشاري"
    },

    // Services
    services: {
      subTitle: "الخدمات",
      title: "استمتع بصحة فم رائعة",
      orthodontic: {
        title: "علاج تقويم الأسنان",
        description: "ابتسم بثقة. يمكن لتقويم الأسنان أن يقوّم أسنانك ويحسّن إطباقك."
      },
      implants: {
        title: "زراعة الأسنان",
        description: "زراعة الأسنان باستخدام زراعات Straumann السويسرية - تيجان الإنترنت (جميع أنواع التيجان) وحشوات الأسنان"
      },
      whitening: {
        title: "تبييض الأسنان",
        description: "تبييض الأسنان بكلا النوعين (تبييض منزلي / تبييض بالليزر) وأحدث الأجهزة وأفضل مواد التبييض الدولية"
      },
      gumCleaning: {
        title: "تنظيف اللثة",
        description: "تنظيف اللثة (قناة واحدة أو قناتين أو ثلاث قنوات) منتظم أو من خلال جهاز الدوران"
      },
      rootCanal: {
        title: "علاج العصب",
        description: "علاج العصب لجميع الأسنان باستخدام أجهزة الدوران وأحدث تقنية لتطهير وحشو قناة الجذر."
      }
    },

    // Features
    features: {
      subTitle: "المميزات",
      title: "رعاية متخصصة من خلال الخبرات",
      description: "تسمح لنا خبرتنا في المجال بتقديم رعاية متخصصة باحترافية وإتقان عالي، بأيدي خفيفة، ولمسات سحرية، وبساعات قليلة لتقديم هذه الخبرة لتكون بين يديك بجميع تفاصيلها.",
      safetyFirst: {
        title: "السلامة أولاً",
        description: "نعطي الأولوية للسلامة مع فحوصات صحية والمزيد"
      },
      insuranceAccepted: {
        title: "قبول التأمين",
        description: "نحن في شبكة مع كبرى شركات التأمين يمكنك الذهاب إلى قسم التأمين للتحقق من تأمينك"
      },
      fullService: {
        title: "طب الأسنان الشامل",
        description: "تقدم عيادتنا مجموعة كاملة من خدمات طب الأسنان، من الفحوصات إلى الزراعة والقشور."
      },
      noJudgment: {
        title: "بدون أحكام أبداً",
        description: "من محبي الخيط إلى محبي الحلويات، كل فم مرحب به."
      }
    },

    // Accredited/Insurance
    accredited: {
      subTitle: "التأمين",
      title: "نحن معتمدون من العديد من شركات التأمين."
    },

    // Appointment
    appointment: {
      subTitle: "احجز موعد",
      title: "الرعاية في مركز الساكت متعة",
      description: "يقدم مركز الساكت لطب الأسنان خدمات شاملة لطب الأسنان. احجز موعدك الآن واستفد من مرافقنا الحديثة وأطباء الأسنان المهرة",
      bookAppointment: "احجز موعد",
      takeCareOfSmile: "اعتنِ بابتسامتك هنا",
      location: "مجمع البنك العربي الطابق الثالث، شارع جبل عرفات، عمان"
    },

    // Contact
    contact: {
      title: "اتصل بنا",
      description: "أسئلة؟ مستعد للجدولة؟ اتصل بنا اليوم. نحن هنا لمساعدتك في تحقيق الابتسامة التي تستحقها."
    },

    // Footer
    footer: {
      description: "مركز الساكت هو عيادة محلية ذات تقييم عالي لطب الأسنان التجميلي والوقائي والترميمي في عمان",
      followUs: "تابعنا على",
      contactInformation: "معلومات الاتصال",
      phoneNumber: "رقم الهاتف",
      openHour: "ساعات العمل",
      clinicAddress: "عنوان العيادة",
      copyright: "عيادات الساكت لطب الأسنان. جميع الحقوق محفوظة 2024"
    }
  }
};

